"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tribunalDKJobReferenceCaseMap = exports.DKTribunalJobType = void 0;
const types_1 = require("../../cases/types");
var DKTribunalJobType;
(function (DKTribunalJobType) {
    DKTribunalJobType["CreateBetalingspaakrav"] = "CREATE_BETALINGSPAAKRAV";
    DKTribunalJobType["ResendBetalingspaakrav"] = "RESEND_BETALINGSPAAKRAV";
    DKTribunalJobType["Register1Paategning"] = "REGISTER_1_PAATEGNING";
    DKTribunalJobType["Register2Paategning"] = "REGISTER_2_PAATEGNING";
    DKTribunalJobType["ClosedObjection"] = "CLOSED_OBJECTION";
    DKTribunalJobType["CreateFogedrekvisition"] = "CREATE_FOGEDREKVISITION";
    DKTribunalJobType["RegisterInsolvency"] = "REGISTER_INSOLVENCY";
    DKTribunalJobType["RegisterPolicePresentation"] = "REGISTER_POLICE_PRESENTATION";
})(DKTribunalJobType || (exports.DKTribunalJobType = DKTribunalJobType = {}));
exports.tribunalDKJobReferenceCaseMap = {
    [DKTribunalJobType.RegisterInsolvency]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
        types_1.TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.CreateBetalingspaakrav]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.ClosedObjection]: [types_1.TribunalCaseType.DKBetalingspaakrav],
    [DKTribunalJobType.Register1Paategning]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.RegisterPolicePresentation]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
        types_1.TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.Register2Paategning]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.ResendBetalingspaakrav]: [
        types_1.TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.CreateFogedrekvisition]: [
        types_1.TribunalCaseType.DKFogedrekvisition,
    ],
};
//# sourceMappingURL=denmark.js.map